import { render, staticRenderFns } from "./Marketplaces.vue?vue&type=template&id=a28db796&scoped=true&"
import script from "./Marketplaces.vue?vue&type=script&lang=js&"
export * from "./Marketplaces.vue?vue&type=script&lang=js&"
import style0 from "./Marketplaces.vue?vue&type=style&index=0&id=a28db796&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a28db796",
  null
  
)

export default component.exports